import * as THREE from 'three'
import Experience from '../Experience'

export default class Outside {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources
    //Options
    this.resource = this.resources.items.outside

    //Methods
    this.setMaterial()
    this.setModel()
  }
  setMaterial() {
    //stand
    this.outsideTexture = this.resources.items.outsideTexture
    this.outsideTexture.flipY = false
    this.outsideTexture.encoding = THREE.sRGBEncoding
    this.outsideMaterial = new THREE.MeshBasicMaterial({ map: this.outsideTexture })
  }
  setModel() {
    this.model = this.resource.scene

    const stand = this.model.children.find(child => child.name === 'stand')
    const tree = this.model.children.find(child => child.name === 'tree')
    stand.material = this.outsideMaterial
    tree.material = this.outsideMaterial

    this.model.scale.set(0.4, 0.4, 0.4)
    this.scene.add(this.model)
  }
}
